/**
 * UI store — transient interaction state.
 * Lock state, command palette open/close, overlays, teleport buffer.
 */

export interface TeleportEntry {
  id: string;
  code: string;
  issuer: string;
  expiresAt: number;
}

class UIStore {
  /** Vault locked? V1 starts unlocked; V2 will toggle on idle/blur. */
  locked = $state(false);

  /** Command palette open/close */
  paletteOpen = $state(false);

  /** Active modal name (or null) */
  activeModal = $state<string | null>(null);
  modalAccountId = $state<string | null>(null);

  /** Stage Mode account id (or null) */
  stageId = $state<string | null>(null);

  /** Code Teleport buffer (15s decay) */
  teleport = $state<TeleportEntry[]>([]);

  /** Site Detective last-detected service key */
  detected = $state<string | null>(null);

  /** Status: are codes hidden globally? (window-blur protection) */
  globalHidden = $state(false);

  openPalette(): void {
    this.paletteOpen = true;
  }
  closePalette(): void {
    this.paletteOpen = false;
  }

  openModal(name: string, accountId: string | null = null): void {
    this.activeModal = name;
    this.modalAccountId = accountId;
  }
  closeModal(): void {
    this.activeModal = null;
    this.modalAccountId = null;
  }

  openStage(id: string): void {
    this.stageId = id;
  }
  closeStage(): void {
    this.stageId = null;
  }

  pushTeleport(id: string, code: string, issuer: string): void {
    const expiresAt = Date.now() + 15_000;
    // Replace existing entry for this account, otherwise prepend
    const filtered = this.teleport.filter((t) => t.id !== id);
    this.teleport = [{ id, code, issuer, expiresAt }, ...filtered].slice(0, 5);
  }

  pruneTeleport(): void {
    const now = Date.now();
    const next = this.teleport.filter((t) => t.expiresAt > now);
    if (next.length !== this.teleport.length) {
      this.teleport = next;
    }
  }

  setDetected(key: string | null): void {
    this.detected = key;
  }

  setGlobalHidden(v: boolean): void {
    this.globalHidden = v;
  }
}

export const ui = new UIStore();
